import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ExplainerPanel from '../../common/components/ExplainerPanel/ExplainerPanel';
import {
  ExplainerPanelSubDescription,
  ExplainerPanelSubDescriptionIcon,
} from '../../common/components/ExplainerPanel/ExplainerPanelProps';
import { FlowConfigContext } from '../../providers/FlowConfigContext';
import withRouteAnalytics from '../../services/analytics/withRouteAnalytics';
import { Screens } from '../../services/analytics/screens';

function SipExplainerScreen(): JSX.Element {
  const navigate = useNavigate();
  const { providerExplainerAcknowledge, setProviderExplainerAcknowledge, selectProvider, navigateToNextFlow } =
    useContext(FlowConfigContext);

  useEffect(() => {
    if (!providerExplainerAcknowledge) {
      return;
    }

    navigateToNextFlow();
  }, [providerExplainerAcknowledge]);

  const handleStartVerificationClick = async () => {
    setProviderExplainerAcknowledge(true);
  };

  const handleBack = () => {
    selectProvider(undefined);
    navigate(-1);
  };

  const subDescriptions: ExplainerPanelSubDescription[] = [
    {
      title: 'screens.start.setup',
      icon: ExplainerPanelSubDescriptionIcon.SHIELD,
      showAppIcons: true,
      showQRCode: true,
    },
  ];

  return (
    <ExplainerPanel
      showHeaderPanel
      subDescriptionsWithIcon={subDescriptions}
      onPrimaryButtonPressed={handleStartVerificationClick}
      showDescription={false}
      showSubDescription={false}
      showSecondaryButton={false}
      showBackButton
      onBackButtonPressed={handleBack}
      dataTestId="IDENTITY_VERIFICATION_HEADER"
    />
  );
}
export default withRouteAnalytics(SipExplainerScreen, Screens.EXPLAINER_SIP);
